// Please extend if needed
export enum FileUploadTypes {
  CSV = 'text/csv',
  PDF = 'application/pdf',
  JPEG = 'image/jpeg',
  ZIP = 'application/zip,application/x-zip-compressed'
}
